export default "__VITE_ASSET__WAcx665q__"